import { render } from "./Footer.vue?vue&type=template&id=251dc8b0"
const script = {}

import exportComponent from "/data03/virt76591/domeenid/www.kuulsaal.ee/bookings-frontend/git/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__